import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import socketIOMiddleware from '../middleware/socketIOMiddleware';
import rootReducer from '../reducers/index';

const loggerMiddleware = createLogger({
  level: 'info',
  collapsed: true,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeWithDevTools;
// const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware))); // uncomment for development
const store = createStore(rootReducer, applyMiddleware(thunkMiddleware)); // uncomment for production

if (process.env.NODE_ENV === 'development') window.appStore = store;

export default store;
